import { IItinerarymap, UserOrganisation } from '@eventr/common'
import {
    ColoursObj,
    Icon,
    MenuButton,
    Typography,
} from '@eventr/common-storybook'
import { Radio, Stack } from '@mui/material'

interface IOrgSelectorProps {
    onSelect: (org: IOrgOption) => void
    selectedOrg?: UserOrganisation
    organisations: IOrgOption[]
}
interface IOrgOption extends UserOrganisation {
    disabled?: boolean
    itinMap?: IItinerarymap[]
}

export const OrgSelector = ({
    onSelect,
    selectedOrg,
    organisations,
}: IOrgSelectorProps) => {
    return (
        <Stack alignItems="center" gap="16px">
            {organisations.map((org: IOrgOption, index: number) => {
                return (
                    <MenuButton
                        id={org.friendlyName}
                        key={index}
                        style={{ background: ColoursObj.backgrounds.secondary }}
                        disabled={org.status === 'creating' || org.disabled}
                        onClick={() => {
                            onSelect(org)
                        }}
                    >
                        <Stack
                            flexDirection="row"
                            gap="16px"
                            alignItems="center"
                        >
                            <Radio
                                style={{ padding: '0px' }}
                                disabled={
                                    org.status === 'creating' || org.disabled
                                }
                                checked={selectedOrg?.name === org.name}
                            />
                            <Typography
                                sx={{
                                    color:
                                        org.status === 'creating' ||
                                        org.disabled
                                            ? ColoursObj.shades.shade2
                                            : ColoursObj.font.primary,
                                }}
                                variant="bodyRegular"
                            >
                                {org.friendlyName ?? org.name}
                            </Typography>
                            {org.status === 'creating' && (
                                <Icon name="Loading" />
                            )}
                        </Stack>
                    </MenuButton>
                )
            })}
        </Stack>
    )
}
